<template>

    <div class="">
		<div class="dm-platform-rating dm-new-rating" 
			@mouseleave="hoveredStar = 0">
			<span class="dm-star"
				v-for="score in 5" 
				:key="'score-' + score"
				:class="{'dm-gold-star' : score <= hoveredStar || (hoveredStar == 0 && score <= ratingData.score)}"
				@mouseover="setHoveredStars(score)"
				@click="setScore(score)"
				>

				<svg-icon icon="star" />
			</span>
		</div>

		<div class="dm-platform-rating-feedback">
			<span>We'd like to hear your feedback, it will help us improve in the future.</span>
			<textarea name="" id="" cols="30" rows="5" class="form-control" placeholder="Message..."
				v-model="ratingData.message"></textarea>

			<div class="text-center">
				<button class="btn dm-submit"
					:class="{'disabled' : !buttonActive}"
					:disabled="!buttonActive"
					@click="submitRating()">Submit</button>
			</div>
		</div>
	</div>

</template>

<script>

export default {
	props: ['location'], /// 'location' can be 'editor-dashboard' or 'frontend'

	data() {
		return {
			ratingModal: null,
			checkedExisting: false,
			hoveredStar: 0,
			ratingData: {
				message: '',
				score: 0
			},
		}
	},

	computed: {
		buttonActive() {
			return this.scoreSelected && this.messageEntered;
		},
		scoreSelected() {
			return this.ratingData.score > 0;
		},
		messageEntered() {
			return Boolean(this.ratingData.message);
		}
	},

	methods: {
		setHoveredStars(score) {
			this.hoveredStar = score
		},
		setScore(score) {
			this.ratingData.score = score
		},
		submitRating() {
			var customSelf = this;

			axios.post('/api/editor/ratings', this.ratingData)
				.then(function (response) {
					customSelf.showThankYouForRatingPopup();

					// Hide modal and remove the yellow button on the side
					if (customSelf.location == 'frontend') {
						customSelf.ratingModal.hide();
						$( "#dm-show-rating-popup" ).remove(); // Removes the front end side button.
					} else {
						$( ".dm-dashboard-rating-card-container").remove() // Removes the editor dashboard rating card
					}
					
				})
		},

		showThankYouForRatingPopup() {
			this.$swal({
				title: "Thank you for your rating!",
				text: "This will help us improve the platform.",
				icon: "success",
				timer: 3500
			})
		}
	},

	mounted() {
		if (this.location == 'editor-dashboard') return;

        var that = this;
        setTimeout(function () {
			// Instantiate Rating modal
            that.ratingModal = new bootstrap.Modal("#dm-rating-popup-modal");

			// Watch clicks on the sidebar rating button to open the modal
			$( "#dm-show-rating-popup" ).click(function() {
				that.ratingModal.show();
			});
        }, 500);
    }
}
</script>
